import { render, staticRenderFns } from "./recruitCompany.vue?vue&type=template&id=0cfe13aa"
import script from "./recruitCompany.vue?vue&type=script&lang=js"
export * from "./recruitCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports